"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var React = require("react"),
  clones_1 = require("./utils/clones"),
  dots_1 = require("./utils/dots"),
  common_1 = require("./utils/common"),
  Dots = function (_a) {
    var props = _a.props,
      state = _a.state,
      goToSlide = _a.goToSlide,
      getState = _a.getState,
      showDots = props.showDots,
      customDot = props.customDot,
      dotListClass = props.dotListClass,
      infinite = props.infinite,
      children = props.children;
    if (!showDots || common_1.notEnoughChildren(state)) return null;
    var numberOfDotsToShow,
      currentSlide = state.currentSlide,
      slidesToShow = state.slidesToShow,
      slidesToSlide = common_1.getSlidesToSlide(state, props),
      childrenArr = React.Children.toArray(children);
    numberOfDotsToShow = infinite ? Math.ceil(childrenArr.length / slidesToSlide) : Math.ceil((childrenArr.length - slidesToShow) / slidesToSlide) + 1;
    var nextSlidesTable = dots_1.getLookupTableForNextSlides(numberOfDotsToShow, state, props, childrenArr),
      lookupTable = clones_1.getOriginalIndexLookupTableByClones(slidesToShow, childrenArr),
      currentSlides = lookupTable[currentSlide];
    return React.createElement("ul", {
      className: "react-multi-carousel-dot-list " + dotListClass
    }, Array(numberOfDotsToShow).fill(0).map(function (_, index) {
      var isActive, nextSlide;
      if (infinite) {
        nextSlide = nextSlidesTable[index];
        var cloneIndex = lookupTable[nextSlide];
        isActive = currentSlides === cloneIndex || cloneIndex <= currentSlides && currentSlides < cloneIndex + slidesToSlide;
      } else {
        var maximumNextSlide = childrenArr.length - slidesToShow,
          possibileNextSlides = index * slidesToSlide;
        isActive = (nextSlide = maximumNextSlide < possibileNextSlides ? maximumNextSlide : possibileNextSlides) === currentSlide || nextSlide < currentSlide && currentSlide < nextSlide + slidesToSlide && currentSlide < childrenArr.length - slidesToShow;
      }
      return customDot ? React.cloneElement(customDot, {
        index: index,
        active: isActive,
        key: index,
        onClick: function () {
          return goToSlide(nextSlide);
        },
        carouselState: getState()
      }) : React.createElement("li", {
        "data-index": index,
        key: index,
        className: "react-multi-carousel-dot " + (isActive ? "react-multi-carousel-dot--active" : "")
      }, React.createElement("button", {
        "aria-label": "Go to slide " + (index + 1),
        onClick: function () {
          return goToSlide(nextSlide);
        }
      }));
    }));
  };
exports.default = Dots;